import styled from 'styled-components';

import { Button, utils } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
`;

const StyledRedoWrapper = styled.div`
  transform: matrix(-1, 0, 0, 1, 0, 0);
`;

export interface UndoRedoProps {
  onUndoClick: () => void;
  onRedoClick: () => void;
  disableUndo: boolean;
  disableRedo: boolean;
}

export function UndoRedo({ onUndoClick, onRedoClick, disableRedo, disableUndo }: UndoRedoProps) {
  const { t } = useTranslation();

  return (
    <StyledWrapper data-context="undo-redo">
      <Button
        icon={{
          name: 'arrow-undo',
        }}
        disabled={disableUndo}
        variant="ghost"
        action="undo"
        title={t('general.undo')}
        onClick={onUndoClick}
      />

      <StyledRedoWrapper>
        <Button
          icon={{
            name: 'arrow-undo',
          }}
          disabled={disableRedo}
          action="redo"
          title={t('general.redo')}
          variant="ghost"
          onClick={onRedoClick}
        />
      </StyledRedoWrapper>
    </StyledWrapper>
  );
}
